import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 'var(--space-4)',
    marginBottom: 'var(--space-8)',
    flexWrap: 'wrap',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    letterSpacing: '-0.02em',
    color: 'var(--text)',
  },
  description: {
    fontSize: 14,
    color: 'var(--text-secondary)',
    marginTop: 4,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--space-2)',
    flexShrink: 0,
  },
}));

/** Standard page title + description + actions row (docs/DESIGN_MAKEOVER.md 4.3). */
const PageHeader = ({ title, description, actions }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box minWidth={0}>
        <Typography className={classes.title}>{title}</Typography>
        {description ? <Typography className={classes.description}>{description}</Typography> : null}
      </Box>
      {actions ? <Box className={classes.actions}>{actions}</Box> : null}
    </Box>
  );
};

export default PageHeader;
